import { namespaceConfig } from 'fast-redux'

type UserState = {
  user_info: any
}

const DEFAULT_STATE: UserState = {
    user_info: {}
}

const { action, getState } = namespaceConfig('live_admin', DEFAULT_STATE)
const getUserState = (state: UserState): UserState=> getState(state)


export const getUserInfo = (state: UserState) => getUserState(state)?.user_info

export const setUserInfo = action('setUserInfo', function (state: UserState, user_info: any) {
    return { ...state, user_info: {...user_info} }
})